









































































import { defineComponent } from '@vue/composition-api';

// 引入工具类
import { useTransmissionForm } from '@/renderer/components/dialog/setting/composition/useTransmissionForm';

// 下载设置
export default defineComponent({
  name: 'UploadSetting',
  setup(props) {
    const {
      formData,
      transmissionMethods,
      defaultTransmissionSetting,
      formRules,
      isEqual,
      confirming,
      toggleMethods,
      speedDecimalPlaces,
    } = useTransmissionForm('upload');

    // 表单交互函数
    const formMethods = {
      onReset(): void {
        transmissionMethods.reset();
      },
    };

    return {
      speedDecimalPlaces,
      defaultTransmissionSetting,
      isEqual,
      confirming,
      formRules,
      formData,
      toggleMethods,
      formMethods,
      transmissionMethods,
    };
  },
});
